import React from "react";
import { useState } from "react";
import patriji from "../images/patriji.png";
import CircleCard from "./CircleCard";

function AboutPatriji() {
  const [collapse, setCollapse] = useState(false);

  return (
    <div className="about-patriji">
      <div className="patriji-title card-title">
        <span>About Beloved Patriji</span>
      </div>

      <div className="patriji-img">
        <img className="patriji-bg-img" src={patriji} alt="patriji img" />

        <div className="patriji-txt">
          <span>
            Brahmarshi Pitamaha Patriji <br />
            Founder of Pyramid Spiritual Societies Movement (PSSM)
          </span>
        </div>

        <div className="patriji-msg">
          <p>
            “Subhash” was born in the year 1947 at Shakkarnagar, Bodhan,
            Nizamabad district (Andhra Pradesh) to Patri Venkata Ramana Rao and
            Savitri Devi.
          </p>

          <p>
            “Subhash” became enlightened in the year 1979, after some serious
            experiments with meditation. Since then, Patriji began striving hard
            to awaken and enlighten each and every individual.
          </p>

          <p>
            In the year 1997, in the temple town of Tirupati, Andhra Pradesh,
            all the pyramid masters gathered and conferred the title of
            “Brahmarshi” on Patriji.
          </p>

          <p>
            Recently, in the year 2018, at the Global Festival of Spiritual
            Scientists in Pyramid Valley International, Bengaluru, Patriji was
            conferred the title “Pitamaha” by the collectivity of Himalayan
            masters.
          </p>

          {/* Optional read more toggle (if you plan to extend bio later) */}
          {collapse && (
            <p>
              Through his teachings and tireless work, Patriji continues to
              inspire millions to embrace meditation, vegetarianism, and
              spiritual wisdom for self-realization and world peace.
            </p>
          )}

          <button
            className="read-more"
            onClick={() => setCollapse((prev) => !prev)}
          >
            {collapse ? "... read less" : "... read more"}
          </button>
        </div>
      </div>

      {/* Optionally show Circle Cards if needed later */}
      {/* <div className="circle-btn-container">
        <CircleCard />
        <CircleCard />
        <CircleCard />
        <CircleCard />
        <CircleCard />
      </div> */}
    </div>
  );
}

export default AboutPatriji;
